import { render } from "./MessageView.vue?vue&type=template&id=8786ff9c&ts=true"
import script from "./MessageView.vue?vue&type=script&lang=ts"
export * from "./MessageView.vue?vue&type=script&lang=ts"

import "./MessageView.vue?vue&type=style&index=0&id=8786ff9c&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_typescript@4.9.5__webpack@5.109.2_postcss@8.5.25_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__